import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';

import Color from '@tool/color';
import moIndex from '../../../store/index';
import { newValue, newRate } from '@tool/index';

const moFreshCategory = observable({
  xData: <any[]>[],
  yData: <any[]>[],
  tableHead: <any[]>[],
  tableList: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
  pageNum: 0,
});

const locateFreshValue = (value: any) => {
  if (isNaN(value)) return '-';
  if (value === null || value === '' || value === undefined) return '-';
  if (value === 0) return '-';
  return Number(value).toLocaleString();
};

const initFreshCategory = action((res: any) => {
  // console.log('+++=== 应届生起薪 按职能 ===+++ ', res.data);
  if (isEmpty(res)) return;

  const xData: any[] = [];
  const yData: any[] = [];
  const overview: any[] = [];
  const labels: any[] = [];
  let tableHead: any[] = [];
  const tableList: any[] = [];

  res.overview?.map((item: any) => {
    let text = '';
    item?.map((child: any) => {
      text += child.value;
    });
    overview.push(text);
  });

  // 大专 associate
  // 本科 bachelor
  // 硕士 master
  // 博士 doctor
  const associateArr: any[] = [];
  const bachelorArr: any[] = [];
  const masterArr: any[] = [];
  const doctorArr: any[] = [];

  // 大专
  res.data?.map((item: any) => {
    xData.push(item.category);
    associateArr.push(item.associate);
  });
  yData.push({ name: '大专', data: associateArr });

  // 本科
  res.data?.map((item: any) => {
    bachelorArr.push(item.bachelor);
  });
  yData.push({ name: '本科', data: bachelorArr });

  // 硕士
  res.data?.map((item: any) => {
    masterArr.push(item.master);
  });
  yData.push({ name: '硕士', data: masterArr });

  // 博士
  res.data?.map((item: any) => {
    doctorArr.push(item.doctor);
  });
  yData.push({ name: '博士', data: doctorArr });

  if (!isEmpty(res.total_category_data)) {
    if (res.total_category_data?.associate !== 0) {
      labels.push({
        value: res.total_category_data?.associate,
        text: '大专平均起薪',
      });
    }
    if (res.total_category_data?.bachelor !== 0) {
      labels.push({
        value: res.total_category_data?.bachelor,
        text: '本科平均起薪',
      });
    }
    if (res.total_category_data?.master !== 0) {
      labels.push({
        value: res.total_category_data?.master,
        text: '硕士平均起薪',
      });
    }
    if (res.total_category_data?.doctor !== 0) {
      labels.push({
        value: res.total_category_data?.doctor,
        text: '博士平均起薪',
      });
    }
  }

  tableHead = [
    { title: '职能类型' },
    {
      title: '大专',
      child: ['不区分'],
    },
    {
      title: '本科',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '硕士',
      child: ['不区分', '普通院校', '重点院校'],
    },
    {
      title: '博士',
      child: ['不区分', '普通院校', '重点院校'],
    },
  ];

  res.data?.map((item: any) => {
    const tempArr: any = [];
    xData.map((child: any) => {
      if (item.category === child) {
        tempArr.push(locateFreshValue(item.associate));
        tempArr.push(locateFreshValue(item.bachelor));
        tempArr.push(locateFreshValue(item.bachelor_common));
        tempArr.push(locateFreshValue(item.bachelor_key));
        tempArr.push(locateFreshValue(item.master));
        tempArr.push(locateFreshValue(item.master_common));
        tempArr.push(locateFreshValue(item.master_key));
        tempArr.push(locateFreshValue(item.doctor));
        tempArr.push(locateFreshValue(item.doctor_common));
        tempArr.push(locateFreshValue(item.doctor_key));
      }
    });
    tableList.push({
      title: item.category,
      arr: tempArr,
    });
  });

  // console.log('xData -- ', xData);
  // console.log('yData -- ', yData);
  // console.log('labels -- ', labels);

  moFreshCategory.xData = xData;
  moFreshCategory.yData = yData;
  moFreshCategory.overview = overview;
  moFreshCategory.labels = labels;
  moFreshCategory.tableHead = tableHead;
  moFreshCategory.tableList = tableList;
});

export default moFreshCategory;
export { initFreshCategory };
